export default "__VITE_ASSET__CTmG3UsV__"